import * as React from 'react';
import { DesktopRating } from '@cian/frontend-reviews-components';
import { ArticleHeading2, LinkButton } from '@cian/ui-kit';
import { Link } from '../../../Link';
import * as style from './ManyReviewsTeaser.css';

export interface IReviewsTitleProps {
  fullUrl: string;
  reviewsCountText: string;
  name: string;
  rating: number;
  isQuestionsFeatureEnabled: boolean;
  title: string;
}

export const ReviewsTitle: React.FC<IReviewsTitleProps> = ({
  fullUrl,
  reviewsCountText,
  name,
  rating,
  isQuestionsFeatureEnabled,
  title,
}) => {
  return (
    <div className={style['container']}>
      <div className={isQuestionsFeatureEnabled ? style['title'] : style['title-legacy']}>
        <ArticleHeading2>
          {isQuestionsFeatureEnabled ? (
            title
          ) : (
            <Link url={`${fullUrl}otzyvy/`} target="blank">
              {reviewsCountText} о {name}
            </Link>
          )}
        </ArticleHeading2>
        {isQuestionsFeatureEnabled && (
          <LinkButton size="XS" theme="stroke_primary" href={`${fullUrl}otzyvy/`} target="blank">
            Показать все
          </LinkButton>
        )}
      </div>
      <DesktopRating value={rating} />
    </div>
  );
};
